module.exports = __webpack_public_path__ + "c4acda79244e1856c7afa7c0a2a8c126.svg";